<template>
  <ul
    :id="id"
    class="nav"
  >
    <slot />
  </ul>
</template>

<script>

export default {
  name: 'VNav',
  props: {
    id: {
      type: String,
      required: false,
      default: null,
    },
  },
};
</script>

<style lang="scss">
.nav {
  height: 100%;
}
</style>
